<template>
  <div class="cs_scrollable_vertical div_container_login">
    <!-- 内容 -->
    <div class="div_content_login">
      <img class="icon_logo_login" src="../assets/image/icon_logo_login.png">
      <div class="cs_align_center title_login">食契餐饮业智慧运营管理平台</div>
      <!--用户名、密码、系统-->
      <div class="div_input_login bg_institution margin_top_69">
        <div class="divider_input"></div>
        <input v-model.trim="institutionId" @keydown="loginByEnterKey" class="edtxt_login" type="text" placeholder="请输入机构号"/>
      </div>
      <div class="div_input_login bg_user_name cs_margin_top_sm">
        <div class="divider_input"></div>
        <input v-model.trim="userName" @keydown="loginByEnterKey" class="edtxt_login" type="text" placeholder="请输入用户名"/>
      </div>
      <div class="div_input_login bg_password cs_margin_top_sm">
        <div class="divider_input"></div>
        <input v-model.trim="password" @keydown="loginByEnterKey" class="edtxt_login" type="password" placeholder="请输入密码" />
      </div>
      <div class="div_input_login bg_system cs_margin_top_sm">
        <div class="divider_input"></div>
        <web-select :options="SYSTEM"
                    @option-key="updateSystem"
                    v-model="systemName"
                    class="edtxt_login"></web-select>
      </div>
      <!--验证码-->
      <div class="div_verify_code_login">
        <input v-model.trim="validateCode" @keydown="loginByEnterKey" class="edtxt_verify_code" type="text" maxlength="4">
        <img :src="imgUrl" class="img_verify_code">
        <div @click="refreshValidateCode()" class="btn_change_code_img">换一张</div>
      </div>
      <div class="cs_margin_top_xs txt_hint" v-if="hasErrorMsg">{{errorMsg}}</div>
      <!--登录按钮-->
      <button @click="clickLogin()" class="cs_margin_top ui_btn_common_gradient btn_login" type="button">登录</button>
    </div>
    <!--选择门店等弹窗，默认隐藏-->
    <div v-if="isDialogShow" class="ui_div_dialog cs_scrollable_vertical">
      <div class="ui_dialog_container" style="width:542px;height:622px;padding: 24px;">
        <div class="ui_divider_title">
          <div class="divider_title_info"></div>
          <div class="title_info">选择登录{{moduleName}}</div>
        </div>
        <div class="cs_margin_top_lg div_table">
          <table class="cs_table cs_thead_fixed cs_td_divider_none" width="100%">
            <thead>
            <tr>
              <th width="44px">序号</th>
              <th width="128px">{{moduleName}}编号</th>
              <th width="100%">{{moduleName}}名称</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(item,index) in moduleList" :class="{ 'cs_tr_selected': item.isSelected}" @click="btnSelectTableTrDialog(item)">
              <td width="44px">{{index+1}}</td>
              <td width="128px">{{item.num}}</td>
              <td width="100%">{{item.name}}</td>
            </tr>
            <template v-if="PAGE_SIZE>moduleList.length">
              <tr v-for="(item,index) in (PAGE_SIZE-moduleList.length)">
                <td width="40px"></td>
                <td width="128px"></td>
                <td width="100%"></td>
              </tr>
            </template>
            </tbody>
          </table>
        </div>
        <!--确定取消按钮-->
        <div class="cs_margin_top div_search cs_align_center">
          <button type="button" class="cs_btn ui_btn_ghost" @click="closeDialog">取消</button>
          <button type="button" class="cs_btn ui_btn_common_gradient ui_margin_left_88" @click="btnConfirmDialog">确定</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import {login,valid} from '../assets/ajax/ajax'
  import WebSelect from "../components/web-select"
  import url from "../assets/ajax/conf";
  import {SYSTEM,WEBAPP_LIST,SYSTEM_VERIFY,SYSTEM_MODULE_LIST} from "../assets/utils/constants"
  import StorageConst from "../assets/utils/StorageConst"
  export default {
    name: "Login",
    components: {WebSelect},
    data() {
      return {
        institutionId:"",
        userName: "",
        password: "",
        validateCode: "",
        imgUrl: "",
        SYSTEM: SYSTEM,
        SYSTEM_VERIFY: SYSTEM_VERIFY,
        SYSTEM_MODULE_LIST: SYSTEM_MODULE_LIST,
        systemId: 0,
        systemName: "",
        hasErrorMsg: false,
        errorMsg: "",
        isDialogShow: false,
        moduleName: "",
        moduleList: [],
        selectedId: "",
        PAGE_SIZE:10,
      }
    },
    created() {
    },
    mounted: function () {
      this.institutionId = this.isEmpty(localStorage.getItem(StorageConst.LOCAL_INSTITUTION_ID))?"":localStorage.getItem(StorageConst.LOCAL_INSTITUTION_ID);
      this.refreshValidateCode();
      if(!this.isEmpty(this.$cookies.get(StorageConst.COOKIE_TOKEN))){
        this.verifyLogin();
      }
    },
    methods: {
      verifyLogin(){
        valid.bind(this)(this.$cookies.get(StorageConst.COOKIE_TOKEN),SYSTEM_VERIFY.OPERATION,(data)=> {
          this.$cookies.set(StorageConst.COOKIE_TOKEN, data.data.token,0);
          sessionStorage.setItem(StorageConst.COOKIE_TOKEN, data.data.token);
          this.$cookies.set(StorageConst.COOKIE_STAFF_NAME, data.data.staffName);
          this.$cookies.set(StorageConst.COOKIE_INSTITUTION_NAME, data.data.institutionName);
          this.setStoreItem(StorageConst.LOCAL_LOGO_URL,data.data.logo);
          this.setStoreItem(StorageConst.LOCAL_INSTITUTION_ID,data.data.institutionId);
          this.$router.push({path:'/home'});
        }, (data)=> {
        }, true);
      },
      refreshValidateCode() {
        this.imgUrl = url.VERIFY_CODE + "?" + Math.random();
      },
      clickLogin() {
        if(this.isEmpty(this.institutionId)){
          this.showErrorMsg("请输入机构号");
          return;
        }
        if(this.isEmpty(this.userName)){
          this.showErrorMsg("请输入用户名");
          return;
        }
        if(this.isEmpty(this.password)){
          this.showErrorMsg("请输入密码");
          return;
        }
        if(this.systemId===0){
          this.showErrorMsg("请选择系统");
          return;
        }
        if(this.isEmpty(this.validateCode)){
          this.showErrorMsg("请输入验证码");
          return;
        }
        login.bind(this)(this.institutionId,this.systemId,this.userName,this.password,this.validateCode, (data) => {
          this.$cookies.set(StorageConst.COOKIE_TOKEN, data.data.token,0);
          sessionStorage.setItem(StorageConst.COOKIE_TOKEN, data.data.token);
          this.$cookies.set(StorageConst.COOKIE_STAFF_NAME, data.data.staffName);
          this.$cookies.set(StorageConst.COOKIE_INSTITUTION_NAME, data.data.institutionName);
          this.setStoreItem(StorageConst.LOCAL_LOGO_URL,data.data.logo);
          this.setStoreItem(StorageConst.LOCAL_INSTITUTION_ID,data.data.institutionId);
          //判断登录系统
          if(this.systemId===SYSTEM_VERIFY.OPERATION){
            this.$router.push({path:'/home'});
            return;
          }
          if(this.systemId===SYSTEM_VERIFY.MANAGE){
            this.systemLogin();
            return;
          }
          if(data.data.moduleList.length===1){
            this.$cookies.set(StorageConst.COOKIE_MODULE_ID, data.data.moduleList[0].id);
            this.systemLogin();
          }else{
            let list = data.data.moduleList;
            list.forEach((item) => {
              item.isSelected = false;
            });
            this.moduleList = list;
            this.moduleName = SYSTEM_MODULE_LIST[this.systemId];
            this.isDialogShow = true;
          }
        }, (data) => {
          this.clearMsg();
          this.refreshValidateCode();
          this.showErrorMsg(data.errorCodeDesc);
        }, true,this.showErrorMsg)
      },
      updateSystem(key) {
        this.systemId = key;
      },

      btnConfirmDialog(){
        if(this.isEmpty(this.selectedId)){
          this.$toast("请选择登录"+this.moduleName);
          return;
        }
        this.$cookies.set(StorageConst.COOKIE_MODULE_ID, this.selectedId);
        this.closeDialog();
        this.systemLogin();
      },
      btnSelectTableTrDialog(item){
        let selectedStatus = item.isSelected;
        this.moduleList.forEach((item1) => {
          item1.isSelected = false;
        });
        item.isSelected = !selectedStatus;
        if(item.isSelected){
          this.selectedId = item.id;
        }else {
          this.selectedId = "";
        }
      },
      closeDialog(){
        this.isDialogShow= false;
        this.moduleList= [];
        this.selectedId= "";
        this.moduleName = "";
      },
      systemLogin(){
        let appUrl = WEBAPP_LIST[this.systemId];
        window.location.href = appUrl + "#/";
      },

      //错误提示
      showErrorMsg(msg) {
        this.hasErrorMsg = true;
        this.errorMsg = msg;
      },
      loginByEnterKey(e) {
        if (e.keyCode === 13) {
          this.clickLogin();
        }
      },
      //清除提示
      clearMsg() {
        this.password = "";
        this.validateCode = "";
      },
    }
  }
</script>

<style scoped>
  .div_container_login {
    position: relative;
    width: 100%;
    height: 100%;
    _height: 900px;
    min-height: 900px;
    background: url("../assets/image/bg_wellcome.png") no-repeat center;
    background-size: 100% 100%;
  }
  .div_content_login {
    position: relative;
    margin: 0 auto;
    width: 372px;
    height: 100%;
    padding-top: 137px;
  }
  .icon_logo_login {
    position: relative;
    margin-left: 146px;
    width: 80px;
    height: 80px;
  }
  .title_login {
    position: relative;
    margin-top: 30px;
    width: 100%;
    height: 28px;
    line-height: 28px;
    font-size: 22px;
    color: #FFFFFF;
    font-weight: bold;
  }
  /*用户名、密码*/
  .div_input_login{
    position: relative;
    width: 372px;
    height: 50px;
    border: 1px #E0E0E5 solid;
    border-radius: 30px;
  }
  .div_input_login:hover{border: 1px #FF9967 solid;}
  .bg_institution{
    background: #FFFFFF url("../assets/image/icon_institution.png") no-repeat 24px center;
    background-size: 20px 20px;
  }
  .bg_user_name{
    background: #FFFFFF url("../assets/image/icon_user_name.png") no-repeat 24px center;
    background-size: 20px 20px;
  }
  .bg_password{
    background: #FFFFFF url("../assets/image/icon_password.png") no-repeat 24px center;
    background-size: 20px 20px;
  }
  .bg_system{
    background: #FFFFFF url("../assets/image/icon_system.png") no-repeat 24px center;
    background-size: 20px 20px;
  }
  .divider_input{
    position: absolute;
    top: 10px;
    left: 63px;
    width: 1px;
    height: 30px;
    border-left: 1px solid #EEEEEE;
  }
  .edtxt_login{
    position: absolute;
    width: 100%;
    height: 50px;
    font-size: 16px;
    color: #333333;
    line-height: 21px;
    text-align: left;
    background: transparent;
    padding: 13px 0 13px 84px;
    border-radius: 30px;
  }
  input::-webkit-input-placeholder{ color: #CCCCCC; }
  input:-moz-placeholder{ color: #CCCCCC; }
  input::-moz-placeholder{ color: #CCCCCC; }
  input:-ms-input-placeholder{ color: #CCCCCC; }
  .margin_top_69{margin-top: 69px;}
  /*验证码*/
  .div_verify_code_login{
    position: relative;
    margin-top: 22px;
    width: 100%;
    height: 38px;
  }
  .edtxt_verify_code{
    position: absolute;
    left: 0;
    width: 206px;
    height: 38px;
    padding: 11px 0 11px 53px;
    line-height: 16px;
    color: #333333;
    font-size: 14px;
    text-align: left;
    background: #F4F7FF;
    letter-spacing: 21px;
    border-radius: 4px;
    box-sizing: border-box;
  }
  .img_verify_code{
    position: absolute;
    left: 224px;
    width: 102px;
    height: 38px;
  }
  .btn_change_code_img{
    position: absolute;
    left: 331px;
    width: 45px;
    height: 37px;
    line-height: 30px;
    text-align: left;
    color: #ffffff;
    transform: scale(0.75);
    font-size: 12px;
    cursor: pointer;
  }
  .txt_hint{
    position: relative;
    width: 100%;
    height: 16px;
    font-size: 10px;
    line-height: 16px;
    color: #ff6666;
  }
  .btn_login{
    position: relative;
    width: 372px;
    height: 50px;
    line-height: 50px;
    font-size: 18px;
    color: #FFFFFF;
    text-align: center;
    border-radius: 40px;
  }
  .cs_table tbody{max-height: 411px;}

  .web_select {
    background: transparent url("../assets/image/icon_select_arrow.png") no-repeat right 24px center !important;
  }
  .web_select ul li {
    text-align: center !important;
  }
  .web_select ul li:hover {
    background: rgba(255,181,76,0.1) !important;
  }
</style>



// WEBPACK FOOTER //
// src/page/Login.vue